module.exports = __webpack_public_path__ + "static/media/Tischdecke_140x320.95c6040b.png";